export const moduleName = 'ApprovalManagementModule';
